import gsap from "gsap";
import { SplitText } from "gsap/SplitText"; // Best practice per i moduli ES con GSAP Premium
import { ScrollTrigger } from "gsap/ScrollTrigger";

// Registriamo i plugin necessari (inclusi gli effetti nativi se usati)
gsap.registerPlugin(SplitText, ScrollTrigger);

// Interfacce per le configurazioni degli effetti custom
interface FadeConfig {
    duration: number;
    x: number;
    y: number;
    distance: number;
    ease: string;
    stagger: gsap.StaggerVars | number;
    scrollTrigger?: object;
}

interface MoveConfig {
    duration: number;
    x: number;
    y: number;
    distance: number;
    delay: number;
    ease: string;
    scrollTrigger?: object;
    stagger: gsap.StaggerVars | number;
}

interface PopUpConfig {
    duration: number;
    delay: number;
    scale: number;
    scrollTrigger?: object;
}

interface WindyFlipConfig {
    duration: number;
    rotation: number;
    ease: string;
    stagger: gsap.StaggerVars | number;
    scrollTrigger?: object;
}

interface SpringyConfig {
    duration: number;
    distance: number;
    stagger: gsap.StaggerVars | number;
    scrollTrigger?: object;
}

interface UpDownConfig {
    duration: number;
    distance: number;
    ease: string;
    stagger: gsap.StaggerVars | number;
    mode: "normal" | "zipper" | "reversed" | "half-zipper";
    scrollTrigger?: object;
}

interface PlayfulConfig {
    delay: number;
    maxMovement: number;
    maxRotation: number;
}

interface NeonConfig {
    duration: number;
    scrollTrigger?: object;
}

const _effettiTestoControls = (() => {
    const init = (): void => {
        // registerFade();
        registerMove();
        registerMoveTitle();
        registerPopUp();
        // registerWindy();
        // registerFlip();
        // registerSpringy();
        // registerUpDown();
        // registerPlayful();
        // registerNeon();

        // const fade = document.querySelectorAll<HTMLElement>(".fade-text");
        // fade.forEach((text) => {
        //     gsap.effects.fade(text, {
        //         y: -1,
        //         distance: 30,
        //         duration: 0.5,
        //         ease: "back.out",
        //         stagger: 0.015,
        //     });
        // });

        const moveL = document.querySelectorAll<HTMLElement>(".move-l-text");
        moveL.forEach((text) => {
            gsap.effects.move(text, {
                duration: 0.3,
                x: 1,
                y: 0,
                distance: 150,
                ease: "power2.out",
                stagger: { from: "start", each: 0.1, ease: "none" },
            });
        });

        const moveLTitle = document.querySelectorAll<HTMLElement>(".move-l-title");
        moveLTitle.forEach((text) => {
            gsap.effects.moveTitle(text, {
                duration: 0.3,
                x: 1,
                y: 0,
                distance: 150,
                ease: "power2.out",
                stagger: { from: "start", each: 0.1, ease: "none" },
            });
        });

        const moveR = document.querySelectorAll<HTMLElement>(".move-r-text");
        moveR.forEach((text) => {
            gsap.effects.move(text, {
                duration: 0.3,
                x: 1,
                y: 0,
                distance: 150,
                ease: "power2.out",
                stagger: { from: "start", each: 0.2, ease: "none" },
            });
        });

        const popUp = document.querySelectorAll<HTMLElement>(".popup-img");
        popUp.forEach((element) => {
            gsap.effects.popup(element, {
                delay: 0,
            });
        });

        const popUpFast = document.querySelectorAll<HTMLElement>(".popup-fast-img");
        popUpFast.forEach((element) => {
            gsap.effects.popup(element, {
                delay: 0.1,
            });
        });

        // const windy = document.querySelectorAll<HTMLElement>(".windy-text");
        // windy.forEach((text) => {
        //     gsap.effects.windy(text, {
        //         duration: 1,
        //         ease: "back.out",
        //     });
        // });

        // const flip = document.querySelectorAll<HTMLElement>(".flip-text");
        // flip.forEach((text) => {
        //     gsap.effects.flip(text, {
        //         duration: 1,
        //         ease: "back.out",
        //     });
        // });

        // const springy = document.querySelectorAll<HTMLElement>(".springy-text");
        // springy.forEach((text) => {
        //     gsap.effects.springy(text, {});
        // });

        // const upDown = document.querySelectorAll<HTMLElement>(".up-down-text");
        // upDown.forEach((text) => {
        //     gsap.effects.upDown(text, {
        //         mode: "normal",
        //     });
        // });

        // const playful = document.querySelectorAll<HTMLElement>(".playful-text");
        // playful.forEach((text) => {
        //     gsap.effects.playful(text, {});
        // });

        // const neon = document.querySelectorAll<HTMLElement>(".neon-text");
        // neon.forEach((text) => {
        //     gsap.effects.neon(text, {});
        // });
    };

    const registerFade = (): void => {
        gsap.registerEffect({
            name: "fade",
            effect: (target: HTMLElement[], config: FadeConfig) => {
                const split = new SplitText(target, { type: "chars, words" });
                return gsap.from(split.chars, {
                    opacity: 0,
                    stagger: config.stagger,
                    ease: config.ease,
                    duration: config.duration,
                    x: -config.x * config.distance,
                    y: -config.y * config.distance,
                    scrollTrigger: config.scrollTrigger ?? {
                        trigger: target,
                        start: "top 70%",
                    },
                });
            },
            defaults: {
                duration: 0.5,
                x: 0,
                y: 0,
                distance: 20,
                ease: "power2.out",
                stagger: { from: "start", each: 0.02, ease: "none" },
            },
            extendTimeline: true,
        });
    };

    const registerMove = (): void => {
        gsap.registerEffect({
            name: "move",
            effect: (target: HTMLElement[], config: MoveConfig) => {
                const split = new SplitText(target, { type: "lines", wordsClass: "word" });
                return gsap.from(split.lines, {
                    opacity: 0,
                    stagger: config.stagger,
                    ease: config.ease,
                    delay: config.delay,
                    duration: config.duration,
                    x: -config.x * config.distance,
                    y: -config.y * config.distance,
                    scrollTrigger: config.scrollTrigger ?? {
                        trigger: target,
                        start: "top 70%",
                        // markers: true,
                    },
                });
            },
            defaults: {
                duration: 0.5,
                x: 0,
                y: 0,
                delay: 0,
                distance: 20,
                ease: "power2.out",
                stagger: { from: "start", each: 0.02, ease: "none" },
            },
            extendTimeline: true,
        });
    };

    const registerMoveTitle = (): void => {
        gsap.registerEffect({
            name: "moveTitle",
            effect: (target: HTMLElement[], config: MoveConfig) => {
                const split = new SplitText(target, { type: "lines", wordsClass: "word" });
                return gsap.from(split.lines, {
                    opacity: 0,
                    stagger: config.stagger,
                    ease: config.ease,
                    delay: config.delay,
                    duration: config.duration,
                    x: -config.x * config.distance,
                    y: -config.y * config.distance,
                });
            },
            defaults: {
                duration: 0.5,
                x: 0,
                y: 0,
                delay: 0,
                distance: 20,
                ease: "power2.out",
                stagger: { from: "start", each: 0.02, ease: "none" },
            },
            extendTimeline: true,
        });
    };

    const registerPopUp = (): void => {
        gsap.registerEffect({
            name: "popup",
            effect: (target: HTMLElement[], config: PopUpConfig) => {
                return gsap.from(target, {
                    scale: config.scale,
                    duration: config.duration,
                    delay: config.delay,
                    ease: "back.out(2)",
                    scrollTrigger: config.scrollTrigger ?? {
                        trigger: target,
                        start: "top 90%",
                    },
                });
            },
            defaults: {
                scale: 0,
                duration: 0.5,
                delay: 2,
            },
            extendTimeline: true,
        });
    };

    const registerWindy = (): void => {
        gsap.registerEffect({
            name: "windy",
            effect: (target: HTMLElement[], config: WindyFlipConfig) => {
                const split = new SplitText(target, { type: "chars, words" });
                split.chars.forEach((char) => {
                    gsap.set(char, { perspective: 500 });
                });

                const tl = gsap.timeline({
                    scrollTrigger: config.scrollTrigger ?? {
                        trigger: target,
                        start: "top 70%",
                    },
                });

                tl.from(split.chars, {
                    opacity: 0,
                    duration: config.duration / 5,
                    stagger: config.stagger,
                }).from(
                    split.chars,
                    {
                        rotateY: -config.rotation,
                        duration: config.duration,
                        stagger: config.stagger,
                        ease: config.ease,
                    },
                    "<",
                );
                return tl;
            },
            defaults: {
                duration: 0.5,
                rotation: -720,
                ease: "back.out",
                stagger: { from: "start", each: 0.02, ease: "none" },
            },
            extendTimeline: true,
        });
    };

    const registerFlip = (): void => {
        gsap.registerEffect({
            name: "flip",
            effect: (target: HTMLElement[], config: WindyFlipConfig) => {
                const split = new SplitText(target, { type: "chars, words" });
                split.chars.forEach((char) => {
                    gsap.set(char, { perspective: 500 });
                });

                const tl = gsap.timeline({
                    scrollTrigger: config.scrollTrigger ?? {
                        trigger: target,
                        start: "top 70%",
                    },
                });

                tl.from(split.chars, {
                    opacity: 0,
                    duration: config.duration / 5,
                    stagger: config.stagger,
                }).from(
                    split.chars,
                    {
                        rotateX: -config.rotation,
                        duration: config.duration,
                        stagger: config.stagger,
                        ease: config.ease,
                    },
                    "<",
                );
                return tl;
            },
            defaults: {
                duration: 0.5,
                rotation: -90,
                ease: "back.out",
                stagger: { from: "start", each: 0.02, ease: "none" },
            },
            extendTimeline: true,
        });
    };

    const registerSpringy = (): void => {
        gsap.registerEffect({
            name: "springy",
            effect: (target: HTMLElement[], config: SpringyConfig) => {
                const split = new SplitText(target, { type: "chars, words" });
                const tl = gsap.timeline({
                    scrollTrigger: config.scrollTrigger ?? {
                        trigger: target,
                        start: "top 70%",
                    },
                    defaults: { stagger: config.stagger },
                });

                tl.set(split.chars, { transformOrigin: "center bottom" });
                tl.from(
                    split.chars,
                    {
                        y: -config.distance,
                        opacity: 0,
                        ease: "power2.in",
                        duration: config.duration * 0.1 * 3,
                    },
                    "<",
                )
                    .to(
                        split.chars,
                        {
                            scaleX: 0.6,
                            scaleY: 1.4,
                            duration: config.duration * 0.1 * 2,
                        },
                        "<",
                    )
                    .to(
                        split.chars,
                        {
                            scaleX: 1.5,
                            scaleY: 0.5,
                            duration: config.duration * 0.1 * 2,
                        },
                        `<+=${config.duration * 0.1 * 2}`,
                    )
                    .to(
                        split.chars,
                        {
                            scaleX: 1,
                            scaleY: 1,
                            duration: config.duration * 0.1 * 1,
                        },
                        `<+=${config.duration * 0.1 * 2}`,
                    );

                return tl;
            },
            defaults: {
                duration: 2,
                distance: 100,
                ease: "none",
                stagger: { from: "start", each: 0.01, ease: "none" },
            },
            extendTimeline: true,
        });
    };

    const registerUpDown = (): void => {
        gsap.registerEffect({
            name: "upDown",
            effect: (target: HTMLElement[], config: UpDownConfig) => {
                const tl = gsap.timeline({
                    scrollTrigger: config.scrollTrigger ?? {
                        trigger: target,
                        start: "top 70%",
                    },
                    defaults: {
                        stagger: config.stagger,
                        duration: config.duration,
                    },
                });

                if (config.mode === "half-zipper") {
                    const lines = new SplitText(target, { type: "lines" });
                    lines.lines.forEach((line, i) => {
                        const split = new SplitText(line, { type: "chars, words" });
                        const rotation = gsap.utils.wrap([-90, 90], i);
                        const box = line.getBoundingClientRect();

                        tl.set(
                            split.chars,
                            {
                                transformOrigin: (_idx: number, elTarget: HTMLElement) => {
                                    const diff = elTarget.getBoundingClientRect().left - box.left;
                                    return `-${config.distance + diff}px center`;
                                },
                            },
                            "<",
                        ).from(
                            split.chars,
                            {
                                opacity: 0,
                                rotate: rotation,
                                stagger: config.stagger,
                                ease: config.ease,
                            },
                            "<",
                        );
                    });
                } else {
                    if (!target[0]) return tl;
                    const box = target[0].getBoundingClientRect();
                    const split = new SplitText(target, { type: "chars, words, lines" });

                    tl.set(split.chars, {
                        transformOrigin: (_idx: number, elTarget: HTMLElement) => {
                            const diff = elTarget.getBoundingClientRect().left - box.left;
                            return `-${config.distance + diff}px center`;
                        },
                    });

                    if (config.mode === "zipper") {
                        tl.from(split.chars, {
                            opacity: 0,
                            rotate: gsap.utils.wrap([-90, 90]),
                            stagger: config.stagger,
                            ease: config.ease,
                        });
                    } else if (config.mode === "reversed") {
                        tl.from(split.chars, {
                            opacity: 0,
                            rotate: 90,
                            stagger: config.stagger,
                            ease: config.ease,
                        });
                    } else {
                        tl.from(split.chars, {
                            opacity: 0,
                            rotate: -90,
                            stagger: config.stagger,
                            ease: config.ease,
                        });
                    }
                }
                return tl;
            },
            defaults: {
                duration: 1,
                distance: 300,
                ease: "back.out",
                stagger: { from: "start", each: 0.01, ease: "none" },
                mode: "normal",
            },
            extendTimeline: true,
        });
    };

    const registerPlayful = (): void => {
        gsap.registerEffect({
            name: "playful",
            effect: (target: Element[], config: PlayfulConfig) => {
                let toMove: Element | Element[] = target;
                if (target.length === 1) {
                    const split = new SplitText(target, { type: "chars, words" });
                    toMove = split.chars;
                }
                const randomMovement = gsap.utils.random(-config.maxMovement, config.maxMovement, 0.1, true);
                const randomRotation = gsap.utils.random(-config.maxRotation, config.maxRotation, 0.1, true);

                return gsap.set(toMove, {
                    x: randomMovement,
                    y: randomMovement,
                    rotation: randomRotation,
                    repeat: -1,
                    repeatRefresh: true,
                    repeatDelay: config.delay,
                });
            },
            defaults: {
                delay: 0.75,
                maxMovement: 5,
                maxRotation: 10,
            },
        });
    };

    const registerNeon = (): void => {
        gsap.registerEffect({
            name: "neon",
            effect: (target: HTMLElement[], config: NeonConfig) => {
                const firstTarget = target[0];
                if (!firstTarget) return;

                const tl = gsap.timeline({
                    scrollTrigger: config.scrollTrigger ?? {
                        trigger: firstTarget,
                        start: "top 70%",
                    },
                    defaults: { duration: config.duration },
                });

                const color = getComputedStyle(firstTarget).getPropertyValue("--text-color") || "#fff";

                tl.fromTo(
                    firstTarget,
                    {
                        webkitTextStroke: "0px transparent",
                        webkitTextFillColor: "transparent",
                        textShadow: "0px 0px 3rem transparent",
                    },
                    {
                        webkitTextStroke: `0.3rem ${color}`,
                        textShadow: `0px 0px 3rem ${color}`,
                        duration: config.duration / 2,
                        // Configurato tramite la stringa corretta di GSAP RoughEase nativa
                        ease: "rough({ template: power4.out, strength: 2, points: 20, taper: none, randomize: true, clamp: false })",
                    },
                );
                return tl;
            },
            defaults: {
                duration: 3,
            },
            extendTimeline: true,
        });
    };

    return {
        init: init,
    };
})();

export default _effettiTestoControls;
